import { ActionReducerMap } from "@ngrx/store";
import { ApikeyReducer, ApikeyState } from "./APIKey/apikey_reducer";
import { ApplicationReducer, ApplicationState } from "./Jobs/jobs_reducer";
import { CRMReducer, CRMState } from "./CRM/crm_reducer";
import { CryptoReducer, CryptoState } from "./Crypto/crypto_reducer";
import { EcommerceState, ecommercerReducer } from "./Ecommerce/ecommerce_reducer";
import { FileManagerReducer, FileManagerState } from "./File Manager/filemanager_reducer";
import { InvoiceReducer, InvoiceState } from "./Invoice/invoice_reducer";
import { LayoutState, layoutReducer } from "./layouts/layout-reducers";
import { ProjectReducer, ProjectState } from "./Project/project_reducer";
import { RiskIntelligenceReducer, RiskIntelligenceState } from "./RiskIntelligence/risk_intelligence_reducer";
import { TaskReducer, TaskState } from "./Task/task_reducer";
import { TicketReducer, TicketState } from "./Ticket/ticket_reducer";
import { TodoReducer, TodoState } from "./Todo/todo_reducer";


export interface RootReducerState {
  APIKey          : ApikeyState;
  CRM             : CRMState;
  Crypto          : CryptoState;
  Ecommerce       : EcommerceState;
  FileManager     : FileManagerState;
  Invoice         : InvoiceState;
  Jobs            : ApplicationState;
  layout          : LayoutState;
  Project         : ProjectState;
  RiskIntelligence: RiskIntelligenceState;
  Task            : TaskState;
  Ticket          : TicketState;
  Todo            : TodoState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
  APIKey          : ApikeyReducer,
  CRM             : CRMReducer,
  Crypto          : CryptoReducer,
  Ecommerce       : ecommercerReducer,
  FileManager     : FileManagerReducer,
  Invoice         : InvoiceReducer,
  Jobs            : ApplicationReducer,
  layout          : layoutReducer,
  Project         : ProjectReducer,
  RiskIntelligence: RiskIntelligenceReducer,
  Task            : TaskReducer,
  Ticket          : TicketReducer,
  Todo            : TodoReducer,
}
